<template>
    <v-card>
        <v-card-title>
            Contact Us
        </v-card-title>
        <v-card-text>
            <v-list flat>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon :color="kingsGold">mdi-phone</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Phone: <a href="tel:519-433-3491">519-433-3491</a> x4700
                        </v-list-item-title>
                        <v-list-item-title>Toll Free: <a href="tel:1-800-265-4406">1-800-265-4406</a> x4700
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon :color="kingsGold">mdi-email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title><a href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon :color="kingsGold">mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            Residence and Campus Life
                        </v-list-item-title>
                        <v-list-item-title>
                            King's University College
                        </v-list-item-title>
                        <v-list-item-title>
                            266 Epworth Avenue
                        </v-list-item-title>
                        <v-list-item-title>
                            London, Ontario, Canada N6A 2M3
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'home-contact',
    computed: {
        kingsGold() {
            return '#d7ae28';
        },
        kingsGreen() {
            return '#004236';
        }
    }

}
</script>

<style scoped>
.v-list-item__subtitle,
.v-list-item__title {
    overflow: initial;
    text-overflow: initial;
    white-space: normal;
}
</style>